import { trackEvent } from "@/services/posthog.service";

export const EVENT_TEAM_CREATED = "MUTATION:TEAM:CREATED";
export const EVENT_TEAM_UPDATED = "MUTATION:TEAM:UPDATED";
export const EVENT_TEAM_DELETED = "MUTATION:TEAM:DELETED";

export const EVENT_TEAM_INVITE_CREATED = "MUTATION:TEAM_INVITE:CREATED";
export const EVENT_TEAM_INVITE_DELETED = "MUTATION:TEAM_INVITE:DELETED";
export const EVENT_TEAM_INVITE_ACCEPTED = "MUTATION:TEAM_INVITE:ACCEPTED";
export const EVENT_TEAM_JOIN = "MUTATION:TEAM_INVITE:JOIN";

export const EVENT_TEAM_INSTANCE_UPDATED = "MUTATION:TEAM:INVITE:CREATED";

type TeamEventType =
  | typeof EVENT_TEAM_CREATED
  | typeof EVENT_TEAM_UPDATED
  | typeof EVENT_TEAM_DELETED
  | typeof EVENT_TEAM_INVITE_CREATED
  | typeof EVENT_TEAM_INVITE_DELETED
  | typeof EVENT_TEAM_INVITE_ACCEPTED
  | typeof EVENT_TEAM_JOIN
  | typeof EVENT_TEAM_INSTANCE_UPDATED;

export const trackTeamEvent = (event: TeamEventType, payload: unknown) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trackEvent(event, payload as any);
};
